<template>
  <div>
    <v-file-input
      :label="label"
      v-model="files"
      :accept="accept"
      show-size
      truncate-length="25"
      @change="uploadFile"
      :disabled="uploading"
      :multiple="multiple"
      :hint="hint" persistent-hint
      :outlined = "outlined"
      :dense = "dense"
    />

    <div v-if="previews.length">
      <v-img v-for="prev in previews" :key="prev" height="150px" contain :src="prev"></v-img>
    </div>
    <div v-if="urls.length" class="mt-2">
      <div v-for="(u, i) in urls" :key="i" class="d-flex align-center uploaded-line">
        <v-icon color="green" small class="mr-1">mdi-check-circle</v-icon>
        <span class="text-truncate uploaded-url">{{ u }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/components/services/http-common'

// Make upload endpoint configurable
export const UPLOAD_URL = 'NasUploads'

export default {
  name: 'FileUpload',
  props: {
    label: { type: String, default: "Upload file" },
    hint: { type: String, default: "" },
    accept: { type: String, default: "*/*" },
    value: { type: [String, Array], default: "" }, // v-model support
    multiple: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    uploadUrl: {type:String, default: UPLOAD_URL}
  },
  data() {
    return {
      files: null,
      urls: Array.isArray(this.value) ? this.value : (this.value ? [this.value] : []),
      uploading: false,
      previews: []
    }
  },
  watch: {
    value(newVal) {
      this.urls = Array.isArray(newVal) ? newVal : (newVal ? [newVal] : [])
      if(!this.urls || this.urls?.length == 0) {
        this.files = null
        this.previews = []
      }
    }
  },

  methods: {
    async uploadFile(files) {
      const fList = Array.isArray(files) ? files : [files]
      if (!fList || !fList.length) return
      try {
        this.uploading = true
        this.$emit("uploading")
        const form = new FormData()

        if (this.multiple) {
          let p = []
          fList.forEach(f => {
            form.append("files", f)
            p.push(URL.createObjectURL(f))
          })
          this.previews = p
          
        } else {
          form.append("file", fList[0])
          this.previews = [URL.createObjectURL(fList[0])]
        }

        // Use configurable UPLOAD_URL
        const response = await http.post(this.uploadUrl, form).then(r => r.data)
        // expect response { message: '...', data: 'https://...' }

        if (Array.isArray(response.data)) {
          this.urls = response.data
        } else if (response.data) {
          this.urls = [response.data]
        } else {
          this.urls = []
        }

        this.$emit("input", this.multiple ? this.urls : this.urls[0] || "")
        this.$emit("uploaded", this.urls)
      } catch (err) {
        console.error("Upload failed:", err)
      } finally {
        this.uploading = false
        this.$emit("uploaded")
      }
    }
  },
}
</script>

<style scoped>
.uploaded-line {
  max-width: 360px;
}
.uploaded-url {
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
